import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Analise Processo',
      to: '/analise-processo',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="AMBIENTE VIRTUAL DO ANALISTA - AVA"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
